module.exports = __webpack_public_path__ + "img/Panama.7bb27782.png";